// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PayrollAccountLinkStartEvent
 */
export var PayrollAccountLinkStart = function (_a) {
    var blockerId = _a.blockerId, clientScenario = _a.clientScenario, flowToken = _a.flowToken;
    return ({
        name: "PayrollAccount Link Start",
        parameters: {
            cdf_entity: "PayrollAccount",
            cdf_action: "Link",
            blocker_id: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PayrollAccountLinkEnterAmountEvent
 */
export var PayrollAccountLinkEnterAmount = function (_a) {
    var unit = _a.unit, value = _a.value;
    return ({
        name: "PayrollAccount Link EnterAmount",
        parameters: {
            cdf_entity: "PayrollAccount",
            cdf_action: "Link",
            unit: unit !== undefined && unit !== null ? unit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value: value !== undefined && value !== null ? value.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PayrollAccountLinkExitEvent
 */
export var PayrollAccountLinkExit = function () { return ({
    name: "PayrollAccount Link Exit",
    parameters: {
        cdf_entity: "PayrollAccount",
        cdf_action: "Link",
    }
}); };
/**
 * @see PayrollAccountLinkCompleteEvent
 */
export var PayrollAccountLinkComplete = function (_a) {
    var accountId = _a.accountId, errorCode = _a.errorCode, errorMessage = _a.errorMessage, errorPendingRetry = _a.errorPendingRetry, job = _a.job, unit = _a.unit, value = _a.value;
    return ({
        name: "PayrollAccount Link Complete",
        parameters: {
            cdf_entity: "PayrollAccount",
            cdf_action: "Link",
            account_id: accountId !== undefined && accountId !== null ? accountId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_pending_retry: errorPendingRetry !== undefined && errorPendingRetry !== null ? errorPendingRetry.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            job: job !== undefined && job !== null ? job.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            unit: unit !== undefined && unit !== null ? unit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value: value !== undefined && value !== null ? value.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PayrollAccountCheckInstantPayEligibilityViewIneligibleUpsellEvent
 */
export var PayrollAccountCheckInstantPayEligibilityViewIneligibleUpsell = function (_a) {
    var source = _a.source, page = _a.page;
    return ({
        name: "PayrollAccount CheckInstantPayEligibility ViewIneligibleUpsell",
        parameters: {
            cdf_entity: "PayrollAccount",
            cdf_action: "CheckInstantPayEligibility",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            page: page !== undefined && page !== null ? page.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
